//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { Toast } from 'mint-ui'
import moment from 'moment'
import oss from '../../utils/oss'
export default {
  name: 'home-page',
  data() {
    return {
      info: {},
      top: 100,
      width: 0,
      height: 0,
      activeKey: '',
      signatureUrl: '',
      fsignatureUrl: '',
      msignatureUrl: '',
      uploadLoading: false
    }
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted: function () {
    this.width = window.screen.width
    this.height = window.screen.height  * 0.3
    document.getElementById('canvas').addEventListener('touchmove', function (e) {
      e.preventDefault()
    }, { passive: false })
    this.getUserInfo()
  },
  updated: function () {
  },
  methods: {
    startSign (type) {
      this.activeKey = type
      this.lineCanvas()
    },
    getDate (createdAt) {
      if (!createdAt) return ''
      return moment(createdAt).format('YYYY/MM/DD')
    },
    lineCanvas(obj) {
      this.lineWidth = 1;
      this.color = '#000';
      this.background = '#fff';
      this.canvas = document.querySelector('#canvas')
      if (!(this.canvas.getContext && this.canvas.getContext('2d'))) {
        this.$notify({ title: '對不起，當前瀏覽器暫不支持此功能！', type: 'error' })
        return
      }
      this.cxt = this.canvas.getContext('2d')
      this.cxt.fillStyle = this.background
      this.cxt.fillRect(0, 0, this.canvas.width, this.canvas.height)
      this.cxt.strokeStyle = this.color
      this.cxt.lineWidth = this.lineWidth
      this.cxt.lineCap = 'round'
      this.cxt.lineJoin = 'round'
      this.cxt.shadowBlur = 1
      this.cxt.shadowColor = '#000'
    },
    handleTouchMove (e) {
      this.cxt.lineTo(e.changedTouches[0].pageX, e.changedTouches[0].pageY - this.top)
      this.cxt.stroke();
    },
    handleTouchStart (e) {
      this.cxt.beginPath();
      this.cxt.moveTo(e.changedTouches[0].pageX, e.changedTouches[0].pageY - this.top);
    },
    handleTouchEnd (e) {
      this.cxt.closePath();
    },
    clearRect () {
      this.cxt.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.cxt.fillStyle = '#fff'
      this.cxt.fillRect(0, 0, this.canvas.width, this.canvas.height);
    },
    cancel () {
      this.activeKey = ''
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight)
      }, 0)
    },
    async saveImg () {
      var imgBase64 = this.canvas.toDataURL();
      this.imgBase64 = imgBase64
      await this.uploadBlobToOSS()
      this.activeKey = ''
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight)
      }, 0)
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    async uploadBlobToOSS () {
      this.uploadLoading = true
      try {
        this.sts = await oss.getSTS()
      } catch (err) {
        this.$notify({ title: '上傳失敗，請重新嘗試', type: 'error' })
      }
      const id = new Date().getTime()
      const blob = this.dataURLtoBlob(this.imgBase64)
      try {
        const result = await oss.putBlob(this.sts.data)(blob, `eyerising-upload/${id}.jpg`)
        this[this.activeKey] = result.url
        this.uploadLoading = false
      } catch (err) {
        this.uploadLoading = false
        this.$notify({ title: '上傳失敗，請重新嘗試', type: 'error' })
      }
    },
    async getUserInfo () {
      const _id = this.$route.query._id
      let result = null
      try {
        result = await this.$store.dispatch('getInfo', {
          _id
        })
      } catch (err) {
        this.$notify({
          title: '請求失敗',
          type: 'error'
        })
      }
      console.log(result)
      var info = result.data.data.info
      this.info = info
    },
    async submitSign () {
      const body = {
        _id: this.$route.query._id,
        signatureUrl: this.signatureUrl,
        fsignatureUrl: this.fsignatureUrl,
        msignatureUrl: this.msignatureUrl
      }
      if (!this.signatureUrl) {
        return Toast({
          message: '受試者請簽名',
          duration: 3000
        })
      }
      if (!this.msignatureUrl || !this.fsignatureUrl) {
        return Toast({
          message: '監護人請簽名',
          duration: 3000
        })
      }
      this.uploadLoading = true
      this.$store.httpDispatch({})('updateUserBackInfo', body).then((res) => {
        const { code } = res.data
        this.uploadLoading = false
        if (code === 0) {
          setTimeout(() => {
            this.$router.push('/')
          }, 3000)
          return Toast({
            message: '提交成功',
            duration: 3000
          })
        }
        if (code === 404) {
          return Toast({
            message: '找不到相關數據，請聯系客服',
            duration: 3000
          })
        }
        if (code === 401) {
          Toast({
            message: '您已經簽過名了哦，不可重復簽名。',
            duration: 3000
          })
        }
      }).catch((err) => {
        console.log(err.data)
        this.uploadLoading = false
        return Toast({
          message: err.data.msg,
          duration: 3000
        })
      })
    }
  }
}
